'use strict';

import React from 'react'

import Layout from '@Layout/FrontOffice'

import Logo from '@Pure/Logo'

let app = window.app

export default class MaintenancePage extends React.Component
{
	componentWillMount ()
	{
		let component = this, props = this.props;

		app.resetFunctions();
	}

	render ()
	{
		const component = this, props = this.props;

		let output =
		(
			<Layout history={ props.history } page_title="Maintenance">

				<div className="u-full-width">
					<div style={
						{
							width: 500,
							maxWidth: '100%',
							margin: 'auto'
						} }>
						<Logo synergies={ true } type="svg" />

						<div className="u-margin-top-20"
							style={ { color: '#FFF', fontSize: 20 } }>
							Le site est actuellement en maintenance, nous reviendrons très bientôt.
						</div>
					</div>
				</div>

			</Layout>
		);

		return output;
	}
}
